/**
 * analytics-datalayer.js
 *
 * Pushes GA4 events to window.dataLayer for GTM to consume. The store uses GTM,
 * so this file ONLY pushes to the dataLayer — it never calls gtag() (that would
 * double-count against the GA4 config tag GTM owns). GTM turns each dataLayer
 * event into a GA4 Event tag; those tags are configured in the GTM admin
 * (see issue #44). Until then these pushes are inert.
 *
 * Subscriber-only: this hooks signals the theme already emits and never touches
 * cart/product logic. New events (FAQ, cart-reminder) are added here by their
 * own issues (#40, #42).
 *
 * NOTE (double-count): Shopify's native Google/GA4 channel may already send
 * `add_to_cart` / `begin_checkout`. Before publishing the GTM tags for these,
 * confirm they are not already flowing to the GA4 property, or one side will be
 * duplicated. See issue #41 / #44.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function toMoney(cents) {
    var n = parseInt(cents, 10);
    return isNaN(n) ? undefined : n / 100;
  }

  // The /cart/add.js response is a single line item, or { items: [...] } for a
  // multi-variant add. Normalize to a GA4 ecommerce items[] array.
  function toItems(product) {
    var list = product && Array.isArray(product.items) ? product.items : [product];
    return list.filter(Boolean).map(function (it) {
      return {
        item_id: it.product_id || it.id,
        item_name: it.product_title || it.title,
        item_variant: it.variant_title || undefined,
        price: toMoney(it.price),
        quantity: it.quantity || 1,
      };
    });
  }

  // add_to_cart — the theme dispatches `product-ajax:added` only on a successful
  // add (theme.js), with detail.product = the /cart/add.js response. This is the
  // add-only signal; the generic cartUpdate pubsub also fires on removes/qty
  // changes and must not be used here.
  document.addEventListener('product-ajax:added', function (event) {
    var product = event.detail && event.detail.product;
    if (!product) return;
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: { items: toItems(product) },
    });
  });

  // begin_checkout — the cart checkout control (main cart form submit button,
  // cart-drawer checkout, or any direct /checkout link). Capture phase so it
  // fires before navigation.
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(
        '[name="checkout"], a[href*="/checkout"], .cart__checkout-button'
      );
      if (!trigger) return;
      window.dataLayer.push({ event: 'begin_checkout' });
    },
    true
  );
})();
